export const LOGIN_FORMS = Object.freeze([
  {
    key: 'login',
    title: 'Login',
    showClose: false,
    width: '492px'
  },
  {
    key: 'forgot-password',
    title: 'Enter Your Email',
    showClose: false,
    width: '492px'
  },
  {
    key: 'send-reset-password',
    title: 'Reset Password',
    showClose: true,
    width: '500px'
  },
  {
    key: 'reset-password',
    title: 'Reset Password',
    showClose: false,
    width: '492px'
  },
  {
    key: 'password-changed',
    title: 'Password Changed!',
    showClose: true,
    width: '500px'
  },
])